import React from 'react';
import ReactDOM from 'react-dom';

import { createHashHistory } from 'History';

import { Router, Route, useRouterHistory } from 'react-router'

import { syncHistoryWithStore, RouterStore } from 'mobx-react-router';

import { Provider } from 'mobx-react';

import WorkflowForm from 'weaWorkflowForm'; //umd

const routing = new RouterStore();

const allStore = {
  routing,
  ...WorkflowForm.store
}

const browserHistory = useRouterHistory(createHashHistory)({
  queryKey: '_key',
  basename: '/'
});

const history = syncHistoryWithStore(browserHistory, allStore.routing);
window.weaWfFormHistory = history;

const Home = props => props.children;

const Root = () => (
  <Provider ecId={`${this && this.props && this.props.ecId || ''}_Provider@9cmoye`} {...allStore}>
    <Router ecId={`${this && this.props && this.props.ecId || ''}_Router@5z1bb7`} history={history}>
      <Route ecId={`${this && this.props && this.props.ecId || ''}_Route@yov1gh`} breadcrumbName="单页入口" path="/main" component={Home}>
        { WorkflowForm.Route }
      </Route>
    </Router>
  </Provider>
);

ReactDOM.render(<Root ecId={`${this && this.props && this.props.ecId || ''}_Root@deflgb`}/>, document.getElementById('container'));



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/single.js